import PropTypes from "prop-types";
import classnamesBind from "classnames/bind";
import styles from "./deferred.css";
import { MODAL_TYPE } from "../constants";
import { useEventListener } from "../useEventListener";
import PageOverlay from "./PageOverlay";

import { useBlockScroll } from "./useBlockScroll";
import { useRenderManagement } from "./useRenderManagement";
import { getClassnamesForModalType } from "./getClassnamesForModalType";

const { SIDE_RIGHT, CENTER, CENTER_LARGE } = MODAL_TYPE;

const classnames = classnamesBind.bind(styles);

const Modal = ({
  open,
  elementReceivingFocusOnClose,
  pageOverlayClickDelegate,
  children,
  modalType,
  forceDOMRewrite = false
}) => {
  const modalClassnames = getClassnamesForModalType(modalType);

  const { shouldRenderModal, shouldRenderPageOverlay } = useRenderManagement({
    open,
    modalType,
    elementReceivingFocusOnClose,
    forceDOMRewrite
  });

  const handleKeyDown = event => {
    if (event.key === "Escape") {
      pageOverlayClickDelegate();
    }
  };

  useEventListener("keydown", handleKeyDown);
  useBlockScroll(open);

  return (
    shouldRenderModal && (
      <>
        {shouldRenderPageOverlay && (
          <PageOverlay
            onClickDelegate={pageOverlayClickDelegate}
            modalClassnames={modalClassnames}
          />
        )}

        <div
          data-testid="modal"
          className={classnames(styles.modal, {
            open,
            ...modalClassnames
          })}
        >
          {children}
        </div>
      </>
    )
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalType: PropTypes.oneOf([SIDE_RIGHT, CENTER, CENTER_LARGE]).isRequired,
  pageOverlayClickDelegate: PropTypes.func.isRequired,
  elementReceivingFocusOnClose: PropTypes.object,
  children: PropTypes.node,
  forceDOMRewrite: PropTypes.bool
};

export default Modal;
